/*
 * Parent controllers
 * Defines the application's controllers
 */

angular
  .module('sms.parent.controllers', [])

  .controller('mainController', function ($scope, $state, reportService) {
    $scope.getYears = function () {
      const currentYear = new Date().getFullYear()
      return _.range(1950, currentYear + 1)
    }
    $scope.getDays = function () {
      return _.range(1, 32)
    }
    $scope.getEmails = function (pen, m, d, y) {
      $scope.isLoading = true
      const query = { pen, m, d, y }
      reportService.getEmails(query).then(function (emails) {
        if (!emails?.length) {
          $scope.isLoading = false
          $scope.hasError = true
          return
        } else {
          $scope.emails = emails
          $scope.isLoading = false
        }
      })
    }
    $scope.sendEmail = function (email, pen, m, d, y) {
      const body = {
        pen: pen.toString(),
        email,
        m: parseInt(m),
        d: parseInt(d),
        y: parseInt(y)
      }
      $scope.emailSending = true
      reportService.generateToken(body).then(function (result) {
        if (result) {
          $scope.emailSent = true
          $scope.emailSending = false
        } else {
          $scope.emailSendError = true
          $scope.emailSending = false
        }
      })
    }
    $scope.finish = function () {
      $state.reload()
    }

    $scope.emails = null
    $scope.emailSent = false
    $scope.emailSending = false
    $scope.emailSendError = null
  })
